import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import {durationToStr} from 'shared';
import {zipObject} from 'lodash';

@Component({
  selector: 'app-fields-interventions-time-repartition-report',
  templateUrl: './fields-interventions-time-repartition-report.component.html',
  styleUrls: ['./fields-interventions-time-repartition-report.component.scss']
})
export class FieldsInterventionsTimeRepartitionReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;
  chartData = [];

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'BU',
      width: 120,
      dataField: 'business_unit_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Operation',
      dataField: 'trailer_operation_type',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Année',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'year',
      area: 'column'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Totale',
      dataField: 'total_duration',
      dataType: 'number',
      format: (value) => {
        return durationToStr(value as number);
      },
      summaryType: 'sum',
      area: 'data'
    }, {
      caption: 'Travail effectif',
      dataField: 'drive_working_duration',
      dataType: 'number',
      format: (value) => {
        return durationToStr(value as number);
      },
      summaryType: 'sum',
      area: 'data'
    }, {
      caption: 'Arrêt',
      dataField: 'stop_working_duration',
      dataType: 'number',
      summaryType: 'sum',
      format: (value) => {
        return durationToStr(value as number);
      },
      area: 'data'
    }, {
      caption: 'Trajet',
      dataField: 'total_road_duration',
      dataType: 'number',
      summaryType: 'sum',
      format: (value) => {
        return durationToStr(value as number);
      },
      area: 'data'
    }]);

    this.dataSource.on('loadingChanged', (isLoading) => {
      if (!isLoading) {
        this.chartData = [];
        const data = this.dataSource.getData();
        const dataAreaFields = this.dataSource.getAreaFields('data', true).map(f => f.caption);
        data.rows.forEach((r) => {
          const el = {name: r.text, data: []};
          dataAreaFields.forEach((c, i) => {
            if (i === 0) {
              return;
            }
            el.data.push({name: c, duration: data.values[r.index][0][i]});
          });
          this.chartData.push(el);
        });
      }
    });

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    /*this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'singleAxis',
      inverted: true,
      alternateDataFields: false,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        /!*chartOptions.valueAxis[0].label = {
          customizeText: (args) => {
            return durationToStr(args.value as number);
          }
        };*!/
        return chartOptions; // This line is optional
      },
    });*/

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  ngOnDestroy(): void {
    this.dataSource.off('loadingChanged');
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + (args.percentText) + ' (' + durationToStr(args.originalValue as number) + ')'
    };
  }
}
